import type { BiomeId } from '@goodtime/shared';
import kingdomUrl from '../../assets/reel/forest_column_bg.webp';
import coveUrl from '../../assets/reel/underwater_column_bg.webp';
import frostUrl from '../../assets/reel/frost_column_bg.webp';
import frontierUrl from '../../assets/reel/frontier_column_bg.webp';
import neonUrl from '../../assets/reel/neon_column_bg.webp';
import egyptUrl from '../../assets/reel/caravan_column_bg.webp';
import candyUrl from '../../assets/reel/sherbet_square_column_bg.webp';

/**
 * Each world's floor on the realm map: the reel floor of the world's first
 * slot (Forest Reels, Stormy Seas, Frost Reels, Dustwood Reels, Neon
 * Reels, Desert Caravan, Sherbet Square), so the world's board, the
 * switcher naming it and its slots' name plates sit on its own ground.
 * The map loads each one when it first needs it.
 */
export const REALM_FLOORS: Readonly<Record<BiomeId, string>> = {
  kingdom: kingdomUrl,
  cove: coveUrl,
  frost: frostUrl,
  frontier: frontierUrl,
  neon: neonUrl,
  egypt: egyptUrl,
  candy: candyUrl,
};
